import { Navigate } from 'react-router-dom';
import { useAiAvailable } from '@/utils/ai';

/**
 * Grind för routes som bara har mening när AI finns i driftsättningen.
 *
 * Ingången till AI-profilen sitter i AI-inställningarna, som döljs utan nyckel — men en
 * route som bara saknar synlig länk är fortfarande nåbar via URL, och en bokmärkt
 * /ai-profile hade lett till ett formulär som fyller i uppgifter åt en AI som inte kan
 * svara. Grinden skickar i stället tillbaka till inställningarna.
 *
 * `replace` så att bakåtknappen inte studsar tillbaka hit igen.
 */
const AiRoute = ({ children }: { children: React.ReactNode }) => {
  const aiAvailable = useAiAvailable();
  if (!aiAvailable) return <Navigate to="/settings" replace />;
  return <>{children}</>;
};

export default AiRoute;
